module.exports = __webpack_public_path__ + "poster5.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/assets/poster5.png
// module id = 1135
// module chunks = 10